import { useState } from "react";
import { useSession } from "../utils/SessionContext";
import api from "../api/api";
import unixTimestamp from "../utils/unixTimestamp";
import { toast } from "react-toastify";

const useRoomAnalysis = () => {
  const { session_id, vendorUrl, product_id } = useSession();
  const [analysisResult, setAnalysisResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const analyzeRoom = async ({ templateImage, roomImageFile }) => {
    const url = `/room_analysis`;
    const params = {
      session_id,
      vendor_url: vendorUrl,
      product_id,
      timestamp: unixTimestamp(),
    };

    if (templateImage) {
      params.template_image = templateImage;
    }

    const config = {
      headers: {
        "Content-Type": roomImageFile ? "multipart/form-data" : "application/json",
      },
    };

    let formData = null;

    if (roomImageFile) {
      formData = new FormData();
      formData.append("room_image_file", roomImageFile);
    }

    try {
      setLoading(true);
      let res;
      if (roomImageFile) {
        res = await api.post(url, formData, {
          params: params,
          ...config,
        });
      } else {
        res = await api.post(url, formData ? formData : null, {
          params: params,
        });
      }
      setAnalysisResult(res.data);
    } catch (err) {
      setError(err.response ? err.response.data : { message: err.message });
      const errorMessage = err.response && err.response.data && err.response.data.detail
                        ? err.response.data.detail
                        : "Something went wrong. Please upload another image.";
      toast.error(errorMessage);
      setLoading(false);
      // setShowModal({ show: true, level: 1 });
    } finally {
      setLoading(false);
    }
  };

  return { analysisResult, error, setError, analyzeRoom, loading };
};

export default useRoomAnalysis;
